function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { TOKEN_KEY, TOKEN_TYPE_KEY, USER_KEY, REFRESH_TOKEN_KEY, ID_TOKEN_KEY, LOGOUT_STATE_KEY, TOKEN_ENDPOINT_URL_KEY, ACCESS_TOKEN_EXPIRES_AT_KEY } from '../types';
import { clearScheduledRefresh } from './web-utils';
export function generateRandomState() {
    var array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode.apply(null, Array.from(array)));
}
export function clearAuthStorage() {
    var preserveLogoutState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ID_TOKEN_KEY);
    if (!preserveLogoutState) {
        localStorage.removeItem(LOGOUT_STATE_KEY);
    }
    localStorage.removeItem(TOKEN_ENDPOINT_URL_KEY);
    localStorage.removeItem(TOKEN_TYPE_KEY);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRES_AT_KEY);
}
export function performLogout(setState, authServerUrl, idTokenHint) {
    return _performLogout.apply(this, arguments);
}
function _performLogout() {
    _performLogout = _async_to_generator(function(setState, authServerUrl, idTokenHint) {
        var tokenExists, performLocalCleanup, state, endSessionEndpoint, postLogoutRedirectUri, logoutUrl, storedIdTokenHint;
        return _ts_generator(this, function(_state) {
            console.log('[WebAuthHandler] Logout function called.', {
                hasIdTokenHint: !!idTokenHint
            });
            tokenExists = !!localStorage.getItem(TOKEN_KEY);
            performLocalCleanup = function() {
                var preserveLogoutState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                console.log('[WebAuthHandler] Performing local cleanup.');
                clearScheduledRefresh();
                setState(function() {
                    return {
                        user: null,
                        token: null,
                        isAuthenticated: false
                    };
                });
                clearAuthStorage(!preserveLogoutState);
            };
            if (tokenExists) {
                console.log('[WebAuthHandler] Token existed. Proceeding with OIDC logout redirection.');
                try {
                    state = generateRandomState();
                    endSessionEndpoint = "".concat(authServerUrl, "/connect/logout");
                    postLogoutRedirectUri = window.location.origin + '/landing?logout=true';
                    logoutUrl = new URL(endSessionEndpoint);
                    storedIdTokenHint = idTokenHint || localStorage.getItem(ID_TOKEN_KEY) || null;
                    // 디버깅: ID 토큰 존재 여부 확인
                    console.log('🔍 [OIDC Logout Debug] ID Token check:', {
                        hasIdTokenHint: !!idTokenHint,
                        hasStoredIdToken: !!localStorage.getItem(ID_TOKEN_KEY),
                        idTokenLength: storedIdTokenHint ? storedIdTokenHint.length : 0,
                        authServerUrl: authServerUrl,
                        endSessionEndpoint: endSessionEndpoint,
                        postLogoutRedirectUri: postLogoutRedirectUri
                    });
                    if (storedIdTokenHint) {
                        logoutUrl.searchParams.append('id_token_hint', storedIdTokenHint);
                        console.log('✅ [OIDC Logout] ID token added to logout URL');
                    } else {
                        console.warn('⚠️ [OIDC Logout] No ID token available - OIDC logout may not work properly!');
                    }
                    logoutUrl.searchParams.append('post_logout_redirect_uri', postLogoutRedirectUri);
                    logoutUrl.searchParams.append('state', state);
                    // 로컬 정리를 먼저 수행 (logout state는 보존)
                    performLocalCleanup(true);
                    localStorage.setItem(LOGOUT_STATE_KEY, state);
                    console.log('🚀 [OIDC Logout] Redirecting to OIDC logout endpoint:', logoutUrl.toString());
                    // OIDC 로그아웃 엔드포인트로 리다이렉트
                    window.location.href = logoutUrl.toString();
                } catch (error) {
                    console.error('❌ [OIDC Logout] Error during OIDC logout preparation:', error);
                    performLocalCleanup();
                    // 에러 발생 시 기본 랜딩 페이지로 이동
                    window.location.href = window.location.origin + '/landing?logout=true';
                }
            } else {
                console.log('[WebAuthHandler] No token existed. Performing local cleanup only.');
                performLocalCleanup();
            }
            return [
                2
            ];
        });
    });
    return _performLogout.apply(this, arguments);
}
